import React, { useState, useEffect, Fragment } from "react";

import { observer } from "mobx-react-lite";
import { makeStyles } from "@mui/styles";
import { useStores } from "../../../core/stores/index";
import "./NewClaim.css";
import { Autocomplete, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import { ICustomer } from "common/interfaces/ICustomer";
import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import CustomAutoComplete from "components/common/CustomAutoComplete";
import { Navigate, useNavigate } from "react-router-dom";
import { ClaimStore } from "core/stores/ClaimStore";
import { IInvoiceSearchRequest } from "common/interfaces/apiRequest/IInvoiceSearchRequest";
import { IInvoice } from "common/interfaces/IInvoice";
import "react-data-grid/lib/styles.css";
//import DataGrid, { Column } from "react-data-grid";
import { Spinner } from "components/common/Spinner";
import { ClaimType } from "common/enums/ClaimType";
import { IoDocumentText } from "react-icons/io5";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { DateHelper } from "common/helpers/DateHelper";

interface NewClaimProp {
    children: JSX.Element;
}

export const NewClaim = observer((props: NewClaimProp) => {
    const { claimStore } = useStores();
    const navigate = useNavigate();
    const [claimType, setClaimTypeSelection] = useState<number>(0);
    const [isClaimTypeValid, setIsClaimTypeValid] = useState<boolean>(true);

    const [showLoader, setShowLoader] = useState<boolean | undefined>(undefined);

    const [customers, setCustomers] = useState<ICustomer[] | undefined>(undefined);

    const [invoices, setInvoices] = useState<IInvoice[]>([]);

    const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | undefined>(undefined);

    const handleClaimTypeSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setClaimTypeSelection(Number(e.target.value));
    };

    const [customerOrderRef, setCustomerOrderRef] = useState<string | undefined>(undefined);
    const [orderNumber, setOrderNumber] = useState<string | undefined>(undefined);
    const [invoiceNumber, setInvoiceNumber] = useState<string | undefined>(undefined);
    const [showLast18Month, setShowLast18Months] = useState<boolean>(true);

    const onCustomerOrderRefChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCustomerOrderRef(e.target.value);
    };

    const onOrderNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setOrderNumber(e.target.value);
    };

    const onInvoiceNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInvoiceNumber(e.target.value);
    };

    const onShowLast18MonthsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShowLast18Months(e.target.checked);
    };

    useEffect(() => {
        if (claimStore.customers.length == 0) {
            claimStore.getCustomers().then((customers) => {
                setCustomers(customers);
                console.log(customers);
            });
        } else {
            setCustomers(claimStore.customers);
        }
    }, []);

    const getAutoCompleteOptions = (customers: ICustomer[]) => {
        return customers.map((x) => ({
            label: `${x.customerAccount}_${x.customerName}`,
            key: `${x.customerAccount}`,
        }));
    };

    const onCustomerChange = (event: any, value: any) => {
        console.log(value);
        //setIsDelegationUserValid(true);
        setSelectedCustomer(value);
    };

    const onSearchHandle = () => {
        if (claimType && claimType > 0) {
            setIsClaimTypeValid(true);
            setShowLoader(true);
            const invoiceSearchRequest: IInvoiceSearchRequest = {
                customerAccountNumber: selectedCustomer?.key,
                invoiceNumber: invoiceNumber,
                claimType: claimType,
                customerOrderRef: customerOrderRef,
                salesOrderNumber: orderNumber,
                showLastEighteenMonths: showLast18Month,
            };

            claimStore.searchInvoice(invoiceSearchRequest).then((invoices) => {
                setInvoices(invoices);
                setShowLoader(false);
            });
        } else {
            setIsClaimTypeValid(false);
        }
    };

    const onCancelClick = () => {
        navigate("/");
    };

    const createClaimHandler = (customerAccount: string, orderDate: string, salesOrderNumber: string, customerOrderRef: string, invoiceNumber: string, invoiceDate: string,claimExists: boolean, claimId: string, currencyCode: string) => {
        const newClaim: IInvoice = {
            customer: customerAccount,
            orderDate: orderDate,
            salesOrderNumber: salesOrderNumber,
            customerOrderRef: customerOrderRef,
            invoiceNumber: invoiceNumber,
            invoiceDate: invoiceDate,
            claimExists: claimExists,
            claimId: claimId,
            currencyCode: currencyCode
        };

        claimStore.setSelectedClaimAndType(newClaim,ClaimType[claimType],claimType);

        navigate("/claimdetails/0");
    }

    const getColumns = () : GridColDef[] => {
        const columns = [
            /// {
            //     key: "claimId",
            //     field: "claimId",
                
            //     width: 50,
            //     headerName: "",
            //     renderCell: (params: any) => <div title="A Claim already exists for this invoice" aria-label="A Claim already exists for this invoice">{params.row.claimExists == true && (<IoDocumentText  className="claim-exist-icons-size"/>)}</div>,
            // },
            {
                key: "claimButton",
                field: "claimButton",
                headerName: "Create Claim",
                width: 120,
                 renderCell: (params: any) => (
                    <a className="hyperink" href="#" onClick={() => createClaimHandler(params.row.customer,params.row.orderDate,params.row.salesOrderNumber,params.row.customerOrderRef,params.row.invoiceNumber,params.row.invoiceDate,params.row.claimExists,params.row.claimId,params.row.currencyCode)}>
                        {"New Claim"}
                    </a>
                ),
            },
            {
                key: "claimExists",
                field: "claimExists",
                width: 50,
                headerName: "",
                renderCell: (params: any) => <div title="A Claim already exists for this invoice" aria-label="A Claim already exists for this invoice">{params.row.claimExists == true && (<IoDocumentText  className="claim-exist-icons-size"/>)}</div>,
            },
            {
                key: "orderNumber",
                field: "orderNumber",
                width: 150,
                headerName: "Sales Order No",
                renderCell: (params: any) => <div>{params.row.salesOrderNumber}</div>,
            },
            {
                key: "customer",
                field: "customer",
                width: 350,
                headerName: "Customer",
                renderCell: (params: any) => <div>{params.row.customer}</div>,
            },
            {
                key: "invoiceNumber",
                field: "invoiceNumber",
                width: 150,
                headerName: "Invoice No",
                renderCell: (params: any) => <div>{params.row.invoiceNumber}</div>,
            },
            {
                key: "invoiceDate",
                field: "invoiceDate",
                width: 150,
                headerName: "Invoice Date",
                renderCell: (params: any) => <div>{DateHelper.getShortTextDate(params.row.invoiceDate,false,false)}</div>,
            },
            {                
                key: "customerOrderNumber",
                field: "customerOrderNumber",
                width: 250,
                headerName: "Customer Order Ref",
                renderCell: (params: any) => <div>{params.row.customerOrderRef}</div>,
            },
            {
                key: "invoiceTotal",
                headerName: "Invoice Total",
                width: 150,
                field: "invoiceTotal",
                renderCell: (params: any) => (
                    <>
                    <div className="p-2">
                        <span className="ms-2">{params.row.currencyCode} </span> {" "}  <span > { params.row.totalInvoiceAmount.toLocaleString()}</span>
                    </div>                   
                    </>
                ),
            },
        ];

        return columns;
    };

    return (
        <div className="container-fluid p-1">
            <div className="m-4 card">
                <div className="col-12 align-content-center">
                    <h1 className="h2 card-header">New Claim - Invoice Search</h1>
                </div>
                <div className="col-12 card-body">
                    <form>
                        <div className="form-row m-1">
                            <div className="form-group row pb-2">
                                <div className="col-md-2">
                                    <label htmlFor="claimtype" className="col-form-label">
                                        Claim Type
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <select
                                        value={claimType}
                                        required
                                        className={isClaimTypeValid ? "form-control" : "form-control is-invalid"}
                                        onChange={(e) => handleClaimTypeSelectionChange(e)}
                                        name="userType"
                                    >
                                        <option selected={true} value={""}>
                                            Select Claim Type
                                        </option>
                                        <option value={1}>Price Claim</option>
                                        <option value={2}>Inventory Claim</option>
                                        <option value={3}>Uplift Request</option>
                                        <option value={4}>RMA</option>
                                        <option value={5}>Ad Hoc</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="col-form-label">Customer Account</label>
                                </div>
                                <div className="col-md-4">
                                    {customers && (
                                        <CustomAutoComplete
                                            selectedValue={selectedCustomer}
                                            onChange={(event: any, value: any) => onCustomerChange(event, value)}
                                            id="selectcustomer"
                                            defaultValue={{ key: "", label: "Select Customer" }}
                                            options={getAutoCompleteOptions(customers as ICustomer[])}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-row m-1">
                            <div className="form-group row pb-2">
                                <div className="col-md-2">
                                    <label htmlFor="claimtype" className="col-form-label">
                                        Customer Order Ref
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="name"
                                        name="name"
                                        required
                                        value={customerOrderRef}
                                        onChange={onCustomerOrderRefChange}
                                        className="form-control"
                                        id="inputName"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="col-form-label">Order No</label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="name"
                                        name="name"
                                        required
                                        value={orderNumber}
                                        onChange={onOrderNoChange}
                                        className="form-control"
                                        id="inputName"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-row m-1">
                            <div className="form-group row pb-2">
                                <div className="col-md-2">
                                    <label htmlFor="claimtype" className="col-form-label">
                                        Invoice No
                                    </label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="name"
                                        name="name"
                                        required
                                        value={invoiceNumber}
                                        onChange={onInvoiceNoChange}
                                        className="form-control"
                                        id="inputName"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="col-form-label">Show Last 18 months</label>
                                </div>
                                <div className="col-md-4">
                                    <input type="checkbox" value="checked" onChange={onShowLast18MonthsChange} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row mt-3">
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={onSearchHandle} type="button">
                                    Search
                                </button>
                                <a className="btn btn-primary ms-1" onClick={onCancelClick}>
                                    Cancel
                                </a>
                            </div>
                        </div>
                        <div className="col-6 my-2 my-lg-0 align-content-center"></div>
                        <div className="row card-body w-100 h-100">
                            <div className="col table-responsive p-2 grid-parent-container">
                                {invoices.length > 0 && getColumns().length > 0 && (
                                    <DataGrid  sx={{
                                        ".MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "600 !important",
                                        },
                                        ".MuiDataGrid-cell": {
                                            fontWeight: "400 !important",
                                        },
                                    }}
                                    getRowId={(row: IInvoice) => row.salesOrderNumber as string}
                                    rows={invoices}
                                    columns={getColumns()}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 30,
                                            },
                                        },
                                    }}
                                    disableRowSelectionOnClick/>
                                )}
                                {showLoader && <Spinner />}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});
